import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6d21d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "fw-bold text-center mb-3 mb-lg-5" }
const _hoisted_3 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto mb-5" }
const _hoisted_4 = { class: "fw-bold fs-6 text-center mb-5" }
const _hoisted_5 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_6 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_7 = { class: "w-max-content col-lg-3" }
const _hoisted_8 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_9 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_10 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_11 = { class: "w-max-content col-lg-3" }
const _hoisted_12 = { class: "mx-0 col-lg-2" }
const _hoisted_13 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_14 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_15 = { class: "w-max-content col-lg-3" }
const _hoisted_16 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_18 = { class: "w-max-content col-lg-3" }
const _hoisted_19 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_20 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-5" }
const _hoisted_21 = { class: "w-max-content col-lg-3" }
const _hoisted_22 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_23 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-5" }
const _hoisted_24 = { class: "w-max-content col-lg-3" }
const _hoisted_25 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_26 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_27 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_28 = { class: "w-max-content col-lg-3" }
const _hoisted_29 = { class: "col-lg-4" }
const _hoisted_30 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_31 = { class: "w-max-content col-lg-3" }
const _hoisted_32 = { class: "col-lg-9" }
const _hoisted_33 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-5" }
const _hoisted_34 = { class: "w-max-content col-lg-3" }
const _hoisted_35 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_36 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_37 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_38 = { class: "w-max-content col-lg-3" }
const _hoisted_39 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_40 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_41 = { class: "w-max-content col-lg-3" }
const _hoisted_42 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_43 = { class: "mx-0 col-lg-7 text-break" }
const _hoisted_44 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-5" }
const _hoisted_45 = { class: "w-max-content col-lg-3" }
const _hoisted_46 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_47 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_48 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-5" }
const _hoisted_49 = { class: "w-max-content col-lg-3" }
const _hoisted_50 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_51 = { class: "inputPass p-0" }
const _hoisted_52 = { class: "mx-0" }
const _hoisted_53 = { class: "fw-bold mb-4 fs-6 py-2 px-2" }
const _hoisted_54 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-5" }
const _hoisted_55 = { class: "w-max-content col-lg-3" }
const _hoisted_56 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_57 = { class: "text-break" }
const _hoisted_58 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3" }
const _hoisted_59 = { class: "w-max-content col-lg-3" }
const _hoisted_60 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_61 = {
  key: 0,
  class: "text-break"
}
const _hoisted_62 = {
  key: 1,
  class: "text-break"
}
const _hoisted_63 = {
  key: 0,
  class: "bg-white p-3 p-lg-5 mb-3 mb-lg-5 shadow rounded-4"
}
const _hoisted_64 = {
  key: 0,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_65 = {
  key: 1,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_66 = { class: "w-max-content col-lg-3" }
const _hoisted_67 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_68 = {
  key: 2,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_69 = { class: "w-max-content col-lg-3" }
const _hoisted_70 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_71 = {
  key: 3,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_72 = { class: "w-max-content col-lg-3" }
const _hoisted_73 = { class: "mx-0 col-lg-2" }
const _hoisted_74 = { class: "mx-0 col-lg-1" }
const _hoisted_75 = { class: "mx-0 col-lg-2" }
const _hoisted_76 = {
  key: 4,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_77 = { class: "w-max-content col-lg-3" }
const _hoisted_78 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_79 = {
  key: 5,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_80 = { class: "w-max-content col-lg-3" }
const _hoisted_81 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_82 = {
  key: 6,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_83 = { class: "w-max-content col-lg-3" }
const _hoisted_84 = { class: "mx-0 col-lg-2" }
const _hoisted_85 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_86 = {
  key: 7,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_87 = {
  key: 8,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_88 = { class: "w-max-content col-lg-3" }
const _hoisted_89 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_90 = {
  key: 9,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_91 = { class: "w-max-content col-lg-3" }
const _hoisted_92 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_93 = {
  key: 10,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_94 = { class: "w-max-content col-lg-3" }
const _hoisted_95 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_96 = {
  key: 11,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_97 = { class: "w-max-content col-lg-3" }
const _hoisted_98 = { class: "mx-0 col-lg-2" }
const _hoisted_99 = { class: "mx-0 col-lg-1" }
const _hoisted_100 = { class: "mx-0 col-lg-2" }
const _hoisted_101 = {
  key: 12,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_102 = { class: "w-max-content col-lg-3" }
const _hoisted_103 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_104 = {
  key: 13,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_105 = { class: "w-max-content col-lg-3" }
const _hoisted_106 = { class: "mx-0 col-lg-9 text-break" }
const _hoisted_107 = {
  key: 14,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_108 = { class: "w-max-content col-lg-3" }
const _hoisted_109 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_110 = { class: "mx-0 col-lg-2 text-break" }
const _hoisted_111 = {
  key: 15,
  class: "fw-bold mb-4 fs-6 py-2 px-2"
}
const _hoisted_112 = {
  key: 16,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_113 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_114 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_115 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_116 = {
  key: 17,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_117 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_118 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_119 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_120 = {
  key: 18,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_121 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_122 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_123 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_124 = {
  key: 19,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_125 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_126 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_127 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_128 = {
  key: 20,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4"
}
const _hoisted_129 = { class: "w-max-content col-lg-3 word-wrapper" }
const _hoisted_130 = {
  key: 0,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_131 = {
  key: 1,
  class: "mx-0 col-lg-9 text-break"
}
const _hoisted_132 = { class: "bg-white shadow rounded-4 p-3 p-lg-5 mb-3 mb-lg-5" }
const _hoisted_133 = { class: "fw-bold fs-6" }
const _hoisted_134 = { class: "row mt-5" }
const _hoisted_135 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_136 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ID } from '../alumni-registration/language/screenId'
import { computed, watchEffect, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { REGISTER_STORE } from '@/store/constants'
import dayjs from 'dayjs'
import { useRoute, useRouter } from 'vue-router'

import { PREFECTURES } from '@/constants/index'
import { getAdditionalInformationDisplayData, removeAlumniIdx, removeAlumniIdxArray } from '@/utils'
import { ALUMNI_QUESTION_TYPE } from '@/constants/common'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const route = useRoute()
const router = useRouter()
const data = computed(() => store.getters[REGISTER_STORE.GETTERS.REGISTER_VALUE])
const inviteData = computed(() => store.getters[REGISTER_STORE.GETTERS.INVITE])
const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])
const listJobs = computed(() => store.getters[REGISTER_STORE.GETTERS.LIST_JOBS])
const termsYelloop = computed(() => store.getters[REGISTER_STORE.GETTERS.TERMS_SERVICE_YELLOOP])
const termsCommunity = computed(() => store.getters[REGISTER_STORE.GETTERS.TERMS_SERVICE_COMMUNITY])
const validPostAlum = computed(() => store.getters[REGISTER_STORE.GETTERS.GET_VALIDATE_POST_ALUMNUS])
const loadingButton = ref<boolean>(false)
const checkConfirm = localStorage.getItem('checkConfirm')
const isErrorAdditionInformation = ref(false)
const communityRequiredDataOld = ref(null)
// console.log('inviteData', inviteData.value)

const backAlumniRegis = () => {
  router.push({ path: '/alumni/register_alumnus', query: { invited_code: route.query?.invited_code } })
  localStorage.removeItem('checkConfirm')
}
watchEffect(() => {
  if (!checkConfirm) router.push({ path: '/alumni/register_alumnus', query: { invited_code: route.query?.invited_code } })
  window.addEventListener('unload', function () {
    localStorage.removeItem('checkConfirm')
  })
})

const fetchRegisterAlumnusCommunityData = async () => {
  if (inviteData.value?.community_id) {
    await store.dispatch(REGISTER_STORE.ACTIONS.SET_COMMUNITY_REQUIRED_COLUMNS, inviteData.value?.community_id)
  }
}

const today = new Date()
const priorDate = new Date('January 1').setFullYear(today.getFullYear() - 30)
const transitComplete = async (): void => {
  loadingButton.value = true
  await store.dispatch(REGISTER_STORE.ACTIONS.SET_VALIDATE_POST_ALUMNUS, {
    community_id: inviteData.value.community_id,
    invited_code: route.query?.invited_code,
    family_name: data.value.family_name,
    given_name: data.value.given_name,
    family_name_kana: data.value.family_name_kana,
    given_name_kana: data.value.given_name_kana,
    display_name: data.value.display_name,
    birthday: dayjs(data.value.birthday).format('YYYY/MM/DD'),
    zipcode_1: data.value.zipcode_judgment ? '' : data.value.zipcode_1,
    zipcode_2: data.value.zipcode_judgment ? '' : data.value.zipcode_2,
    zipcode_judgment: data.value.zipcode_judgment,
    zipcode_foreign: data.value.zipcode_judgment ? data.value.zipcode_foreign : '',
    address_1: data.value.address_1,
    address_2: data.value.address_2,
    phone_number_1: data.value.phone_number_1,
    phone_number_2: data.value.phone_number_2,
    phone_number_3: data.value.phone_number_3,
    email: data.value.email,
    institution: data.value.institution,
    job_type_parent_id: data.value.job_type_parent_id,
    job_type_child_id: data.value.job_type_child_id,
    enrollment_start_period: dayjs(data.value.enrollment_start_period).format('YYYY/MM/DD'),
    password: data.value.password,
    secondary_password: data.value.secondary_password,
    consent_of_yelloop: data.value.consent_of_yelloop,
    consent_of_community: data.value.consent_of_community,
    version_of_yelloop: termsYelloop.value.id,
    version_of_community: termsCommunity.value.id,
    authentication_method: data.value.authentication_method === AuthenMethodTypes.EMAIL ? 2 : 1,
    alumni_community_informations: {
      display_name: data.value.display_name,
      corporation_organization_name: data.value.corporation_organization_name,
      corporation_department_name: data.value.corporation_department_name,
      corporation_start_period:
        communityRequiredData.value.corporation_start_period && data.value.corporation_start_period ? dayjs(data.value.corporation_start_period).format('YYYY/MM/DD') : null,
      corporation_end_period:
        communityRequiredData.value.corporation_end_period && data.value.corporation_end_period ? dayjs(data.value.corporation_end_period).format('YYYY/MM/DD') : null,
      corporation_employee_id: data.value.corporation_employee_id,
      corporation_email: data.value.corporation_email,
      corporation_family_name: data.value.corporation_family_name,
      corporation_given_name: data.value.corporation_given_name,
      school_organization_name: data.value.school_organization_name,
      school_faclty_name: data.value.school_faclty_name,
      school_department_name: data.value.school_department_name,
      school_start_period: communityRequiredData.value.school_start_period && data.value.school_start_period ? dayjs(data.value.school_start_period).format('YYYY/MM/DD') : null,
      school_end_period: communityRequiredData.value.school_end_period && data.value.school_end_period ? dayjs(data.value.school_end_period).format('YYYY/MM/DD') : null,
      school_student_id: data.value.school_student_id,
      school_email: data.value.school_email,
      school_family_name: data.value.school_family_name,
      school_given_name: data.value.school_given_name,
      additional_information_1_type: communityRequiredData.value.additional_information_1_setting?.type,
      additional_information_2_type: communityRequiredData.value.additional_information_2_setting?.type,
      additional_information_3_type: communityRequiredData.value.additional_information_3_setting?.type,
      additional_information_4_type: communityRequiredData.value.additional_information_4_setting?.type,
      additional_information_5_type: communityRequiredData.value.additional_information_5_setting?.type,
      additional_information_1: removeAlumniIdxArray(data.value.additional_information_1),
      additional_information_2: removeAlumniIdxArray(data.value.additional_information_2),
      additional_information_3: removeAlumniIdxArray(data.value.additional_information_3),
      additional_information_4: removeAlumniIdxArray(data.value.additional_information_4),
      additional_information_5: removeAlumniIdxArray(data.value.additional_information_5),
    },
  })
  if (!validPostAlum.value) {
    router.push('/alumni/register_alumnus_mailed')
    await store.dispatch(REGISTER_STORE.ACTIONS.SET_REGISTER_VALUE, {
      invited_code: route.query?.invited_code,
      family_name: '',
      given_name: '',
      family_name_kana: '',
      given_name_kana: '',
      display_name: '',
      birthday: priorDate,
      zipcode_1: '',
      zipcode_2: '',
      zipcode_judgment: false,
      zipcode_foreign: '',
      address_1: '',
      address_2: '',
      phone_number_1: '',
      phone_number_2: '',
      phone_number_3: '',
      email: '',
      institution: '',
      job_type_parent_id: 1,
      job_type_child_id: 1,
      enrollment_start_period: new Date(),
      password: '',
      confirmPassword: '',
      corporation_department_name: '',
      corporation_start_period: new Date(),
      corporation_end_period: new Date(),
      corporation_employee_id: '',
      corporation_email: '',
      corporation_family_name: '',
      corporation_given_name: '',
      consent_of_yelloop: false,
      consent_of_community: false,
      version_of_yelloop: 1,
      version_of_community: 2,
      school_faclty_name: '',
      school_department_name: '',
      school_start_period: new Date(),
      school_end_period: new Date(),
      school_student_id: '',
      school_email: '',

      school_family_name: '',
      school_given_name: '',

      additional_information_1: '',
      additional_information_2: '',
      additional_information_3: '',
      additional_information_4: '',
      additional_information_5: '',
      authentication_method: AuthenMethodTypes.SMS,
    })
  } else {
    communityRequiredDataOld.value = communityRequiredData.value
    // console.log('registerAlumnusCommunityData ban dau: ', communityRequiredDataOld)
    if (validPostAlum.value == 'ERROR_ADDITIONAL_INFORMATIONS') {
      isErrorAdditionInformation.value = true
      fetchRegisterAlumnusCommunityData()
      loadingButton.value = false
      // console.log('communityRequiredData luc sau: ', communityRequiredData.value)
      // router.push({ path: '/alumni/register_alumnus', query: { invited_code: route.query?.invited_code } })
    } else {
      router.push({ path: '/alumni/register_alumnus', query: { invited_code: route.query?.invited_code } })
    }
  }
  localStorage.removeItem('checkConfirm')
  localStorage.setItem('checkSubmit', true)
  loadingButton.value = false
}

watch(
  () => communityRequiredData,
  async () => {
    if (isErrorAdditionInformation.value) {
      // console.log('communityRequiredData ban dau 2:re ', communityRequiredDataOld.value)
      // console.log('communityRequiredData luc sau2: re', communityRequiredData.value)

      var additional_information_1_new = data.value.additional_information_1
      var additional_information_2_new = data.value.additional_information_2
      var additional_information_3_new = data.value.additional_information_3
      var additional_information_4_new = data.value.additional_information_4
      var additional_information_5_new = data.value.additional_information_5
      if (communityRequiredDataOld?.value?.additional_information_1_setting?.type !== communityRequiredData.value.additional_information_1_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_1_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_1_new = []
        } else {
          additional_information_1_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_2_setting?.type !== communityRequiredData.value.additional_information_2_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_2_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_2_new = []
        } else {
          additional_information_2_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_3_setting?.type !== communityRequiredData.value.additional_information_3_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_3_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_3_new = []
        } else {
          additional_information_3_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_4_setting?.type !== communityRequiredData.value.additional_information_4_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_4_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_4_new = []
        } else {
          additional_information_4_new = ''
        }
      }
      if (communityRequiredDataOld?.value?.additional_information_5_setting?.type !== communityRequiredData.value.additional_information_5_setting.type) {
        //If setting type not same setting old => reset
        if (communityRequiredData.value.additional_information_5_setting.type == ALUMNI_QUESTION_TYPE.MULTIPLE_CHOICE) {
          additional_information_5_new = []
        } else {
          additional_information_5_new = ''
        }
      }

      const newData = {
        ...data.value,
        additional_information_1: additional_information_1_new,
        additional_information_2: additional_information_2_new,
        additional_information_3: additional_information_3_new,
        additional_information_4: additional_information_4_new,
        additional_information_5: additional_information_5_new,
      }
      // console.log('newData re', newData)
      store.dispatch(REGISTER_STORE.ACTIONS.SET_REGISTER_VALUE, newData)
      router.push({ path: '/alumni/register_alumnus', query: { invited_code: route.query?.invited_code } })
      isErrorAdditionInformation.value = false
    }
  },
  {
    deep: true,
    immediate: true,
  }
)

const disableCorporation = (communityRequiredData: any) => {
  if (
    communityRequiredData?.corporation_organization_name == 0 &&
    communityRequiredData?.corporation_department_name == 0 &&
    communityRequiredData?.corporation_email == 0 &&
    communityRequiredData?.corporation_employee_id == 0 &&
    communityRequiredData?.corporation_end_period == 0 &&
    communityRequiredData?.corporation_family_name == 0 &&
    communityRequiredData?.corporation_given_name == 0 &&
    communityRequiredData?.corporation_start_period == 0
  ) {
    return true
  }
  return false
}
const disableSchool = (communityRequiredData: any) => {
  if (
    communityRequiredData?.school_organization_name === 0 &&
    communityRequiredData?.school_department_name === 0 &&
    communityRequiredData?.school_email === 0 &&
    communityRequiredData?.school_end_period === 0 &&
    communityRequiredData?.school_faclty_name === 0 &&
    communityRequiredData?.school_family_name === 0 &&
    communityRequiredData?.school_given_name === 0 &&
    communityRequiredData?.school_start_period === 0 &&
    communityRequiredData?.school_student_id === 0
  ) {
    return true
  }
  return false
}
const disableInformation = (communityRequiredData: any) => {
  if (
    communityRequiredData?.additional_information_1 === 0 &&
    communityRequiredData?.additional_information_2 === 0 &&
    communityRequiredData?.additional_information_3 === 0 &&
    communityRequiredData?.additional_information_4 === 0 &&
    communityRequiredData?.additional_information_5 === 0
  ) {
    return true
  }
  return false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(inviteData).corporation_name) + " " + _toDisplayString(_unref(inviteData).community_name) + " " + _toDisplayString(_unref(translate)('invited1')), 1),
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translate)(`SA20titleComfirm`)), 1),
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(translate)(`basicInformation`)), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)(`${_unref(ID)}fullName`)), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(data).family_name), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(data).given_name), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)(`nameKatakana`)), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(data).family_name_kana), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(data).given_name_kana), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)(`${_unref(ID)}nickName`)), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(data).display_name), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('email')), 1),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(data).email), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)(`${_unref(ID)}birthday`)), 1),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(dayjs)(_unref(data).birthday).format('YYYY/MM/DD')), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)(`${_unref(ID)}zipcode`)), 1),
          (_unref(data).zipcode_judgment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(data).zipcode_foreign), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(data).zipcode_1) + "-" + _toDisplayString(_unref(data).zipcode_2), 1))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(translate)('address1')), 1),
          _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(PREFECTURES).find((item) => item.id == _unref(data).address_1)?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(translate)('address2')), 1),
          _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(data).address_2), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)(`${_unref(ID)}phoneNumber`)), 1),
          _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1)
        ]),
        _createElementVNode("h3", _hoisted_36, _toDisplayString(_unref(translate)('SD40currentJob2')), 1),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)(`${_unref(ID)}affiliation`)), 1),
          _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(data).institution), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)(`${_unref(ID)}job`)), 1),
          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(listJobs)?.find((e) => e.id === _unref(data).job_type_parent_id)?.name), 1),
          _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(listJobs)?.find((e) => e.id === _unref(data).job_type_parent_id)?.child?.find((el) => el.id === _unref(data).job_type_child_id)?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)(`${_unref(ID)}dependent`)), 1),
          _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(dayjs)(_unref(data).enrollment_start_period).format('YYYY/M')) + " " + _toDisplayString(_unref(translate)('SA20from')) + " " + _toDisplayString(_unref(translate)('SA20now')), 1)
        ]),
        _createElementVNode("h3", _hoisted_47, _toDisplayString(_unref(translate)(`${_unref(ID)}passwordSecret`)), 1),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)(`password`)), 1),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("span", _hoisted_51, _toDisplayString('*'.repeat(_unref(data).password.length)), 1),
            _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(translate)('hiddenPassword')), 1)
          ])
        ]),
        _createElementVNode("h3", _hoisted_53, _toDisplayString(_unref(translate)(`twoFA`)), 1),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(translate)(`method`)), 1),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(translate)(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? `useSMS` : `useEmail`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("label", _hoisted_59, _toDisplayString(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)(`phone`) : _unref(translate)(`email`)), 1),
          _createElementVNode("div", _hoisted_60, [
            (_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_unref(data).email), 1))
          ])
        ])
      ]),
      (!disableCorporation(_unref(communityRequiredData)) || !disableSchool(_unref(communityRequiredData)) || !disableInformation(_unref(communityRequiredData)))
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            (!disableCorporation(_unref(communityRequiredData)))
              ? (_openBlock(), _createElementBlock("h3", _hoisted_64, _toDisplayString(_unref(translate)(`${_unref(ID)}enrollment`)), 1))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).corporation_organization_name === 1 || _unref(communityRequiredData).corporation_organization_name === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(translate)(`${_unref(ID)}corporationOrganizationName`)), 1),
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(data).corporation_organization_name), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).corporation_department_name === 1 || _unref(communityRequiredData).corporation_department_name === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createElementVNode("label", _hoisted_69, _toDisplayString(_unref(translate)(`${_unref(ID)}department`)), 1),
                  _createElementVNode("div", _hoisted_70, _toDisplayString(_unref(data).corporation_department_name), 1)
                ]))
              : _createCommentVNode("", true),
            (
            (_unref(communityRequiredData).corporation_start_period === 1 && _unref(communityRequiredData).corporation_end_period === 1) ||
            (_unref(communityRequiredData).corporation_start_period === 2 && _unref(communityRequiredData).corporation_end_period === 2)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _createElementVNode("label", _hoisted_72, _toDisplayString(_unref(translate)(`${_unref(ID)}enrollmentPeriod`)), 1),
                  _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(data).corporation_start_period ? _unref(dayjs)(_unref(data).corporation_start_period).format('YYYY/MM') : ''), 1),
                  _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(translate)('SA20from')), 1),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(_unref(data).corporation_end_period ? _unref(dayjs)(_unref(data).corporation_end_period).format('YYYY/MM') : ''), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).corporation_employee_id === 1 || _unref(communityRequiredData).corporation_employee_id === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _createElementVNode("label", _hoisted_77, _toDisplayString(_unref(translate)(`${_unref(ID)}employeeID`)), 1),
                  _createElementVNode("div", _hoisted_78, _toDisplayString(_unref(data).corporation_employee_id), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).corporation_email === 1 || _unref(communityRequiredData).corporation_email === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(translate)(`${_unref(ID)}emailEnrollment`)), 1),
                  _createElementVNode("div", _hoisted_81, _toDisplayString(_unref(data).corporation_email), 1)
                ]))
              : _createCommentVNode("", true),
            (
            (_unref(communityRequiredData).corporation_family_name === 1 && _unref(communityRequiredData).corporation_given_name === 1) ||
            (_unref(communityRequiredData).corporation_family_name === 2 && _unref(communityRequiredData).corporation_given_name === 2)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                  _createElementVNode("label", _hoisted_83, _toDisplayString(_unref(translate)(`OE30nameAtTime`)), 1),
                  _createElementVNode("div", _hoisted_84, _toDisplayString(_unref(data).corporation_family_name), 1),
                  _createElementVNode("div", _hoisted_85, _toDisplayString(_unref(data).corporation_given_name), 1)
                ]))
              : _createCommentVNode("", true),
            (!disableSchool(_unref(communityRequiredData)))
              ? (_openBlock(), _createElementBlock("h3", _hoisted_86, _toDisplayString(_unref(translate)(`${_unref(ID)}informationAtSchool`)), 1))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).school_organization_name === 1 || _unref(communityRequiredData).school_organization_name === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _createElementVNode("label", _hoisted_88, _toDisplayString(_unref(translate)(`${_unref(ID)}schoolOrganizationName`)), 1),
                  _createElementVNode("div", _hoisted_89, _toDisplayString(_unref(data).school_organization_name), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).school_faclty_name === 1 || _unref(communityRequiredData).school_faclty_name === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createElementVNode("label", _hoisted_91, _toDisplayString(_unref(translate)(`${_unref(ID)}facultyName`)), 1),
                  _createElementVNode("div", _hoisted_92, _toDisplayString(_unref(data).school_faclty_name), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).school_department_name === 1 || _unref(communityRequiredData).school_department_name === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  _createElementVNode("label", _hoisted_94, _toDisplayString(_unref(translate)(`${_unref(ID)}departmentName`)), 1),
                  _createElementVNode("div", _hoisted_95, _toDisplayString(_unref(data).school_department_name), 1)
                ]))
              : _createCommentVNode("", true),
            (
            (_unref(communityRequiredData).school_start_period === 1 && _unref(communityRequiredData).school_end_period === 1) ||
            (_unref(communityRequiredData).school_start_period === 2 && _unref(communityRequiredData).school_end_period === 2)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("label", _hoisted_97, _toDisplayString(_unref(translate)(`${_unref(ID)}periodOfEnrollment`)), 1),
                  _createElementVNode("div", _hoisted_98, _toDisplayString(_unref(data).school_start_period ? _unref(dayjs)(_unref(data).school_start_period).format('YYYY/MM') : ''), 1),
                  _createElementVNode("div", _hoisted_99, _toDisplayString(_unref(translate)(`${_unref(ID)}from`)), 1),
                  _createElementVNode("div", _hoisted_100, _toDisplayString(_unref(data).school_end_period ? _unref(dayjs)(_unref(data).school_end_period).format('YYYY/MM') : ''), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).school_student_id === 1 || _unref(communityRequiredData).school_student_id === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _createElementVNode("label", _hoisted_102, _toDisplayString(_unref(translate)(`${_unref(ID)}studentID`)), 1),
                  _createElementVNode("div", _hoisted_103, _toDisplayString(_unref(data).school_student_id), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).school_email === 1 || _unref(communityRequiredData).school_email === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  _createElementVNode("label", _hoisted_105, _toDisplayString(_unref(translate)(`${_unref(ID)}emailAttendSchool`)), 1),
                  _createElementVNode("div", _hoisted_106, _toDisplayString(_unref(data).school_email), 1)
                ]))
              : _createCommentVNode("", true),
            (
            (_unref(communityRequiredData).school_family_name === 1 && _unref(communityRequiredData).school_given_name === 1) ||
            (_unref(communityRequiredData).school_family_name === 2 && _unref(communityRequiredData).school_given_name === 2)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                  _createElementVNode("label", _hoisted_108, _toDisplayString(_unref(translate)(`${_unref(ID)}nameAtSchool`)), 1),
                  _createElementVNode("div", _hoisted_109, _toDisplayString(_unref(data).school_family_name), 1),
                  _createElementVNode("div", _hoisted_110, _toDisplayString(_unref(data).school_given_name), 1)
                ]))
              : _createCommentVNode("", true),
            (!disableInformation(_unref(communityRequiredData)))
              ? (_openBlock(), _createElementBlock("h3", _hoisted_111, _toDisplayString(_unref(translate)(`${_unref(ID)}additionalInformation`)), 1))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).additional_information_1 === 1 || _unref(communityRequiredData).additional_information_1 === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                  _createElementVNode("label", _hoisted_113, _toDisplayString(_unref(communityRequiredData).additional_information_1_question), 1),
                  (_unref(communityRequiredData).additional_information_1_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_1), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_115, _toDisplayString(_unref(data)?.additional_information_1), 1))
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).additional_information_2 === 1 || _unref(communityRequiredData).additional_information_2 === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                  _createElementVNode("label", _hoisted_117, _toDisplayString(_unref(communityRequiredData).additional_information_2_question), 1),
                  (_unref(communityRequiredData).additional_information_2_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_2), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(_unref(data)?.additional_information_2), 1))
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).additional_information_3 === 1 || _unref(communityRequiredData).additional_information_3 === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                  _createElementVNode("label", _hoisted_121, _toDisplayString(_unref(communityRequiredData).additional_information_3_question), 1),
                  (_unref(communityRequiredData).additional_information_3_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_3), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_123, _toDisplayString(_unref(data)?.additional_information_3), 1))
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).additional_information_4 === 1 || _unref(communityRequiredData).additional_information_4 === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                  _createElementVNode("label", _hoisted_125, _toDisplayString(_unref(communityRequiredData).additional_information_4_question), 1),
                  (_unref(communityRequiredData).additional_information_4_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_4), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_127, _toDisplayString(_unref(data)?.additional_information_4), 1))
                ]))
              : _createCommentVNode("", true),
            (_unref(communityRequiredData).additional_information_5 === 1 || _unref(communityRequiredData).additional_information_5 === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                  _createElementVNode("label", _hoisted_129, _toDisplayString(_unref(communityRequiredData).additional_information_5_question), 1),
                  (_unref(communityRequiredData).additional_information_5_setting.type === _unref(ALUMNI_QUESTION_TYPE).MULTIPLE_CHOICE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAdditionalInformationDisplayData)(_unref(data)?.additional_information_5), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_unref(removeAlumniIdx)(item)), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_131, _toDisplayString(_unref(data)?.additional_information_5), 1))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_132, [
        _createElementVNode("h1", _hoisted_133, _toDisplayString(_unref(translate)('consent')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_unref(translate)('SA20yelloopCheck')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(inviteData).community_name) + _toDisplayString(_unref(translate)('SA20termCommunity')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_134, [
        _createElementVNode("div", _hoisted_135, [
          _createVNode(Button, {
            title: _unref(translate)('titleButtonEdit'),
            type: 'secondary',
            onClick: backAlumniRegis
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_136, [
          _createVNode(Button, {
            title: _unref(translate)('titleRegis'),
            type: 'secondary',
            loading: loadingButton.value,
            onClick: transitComplete,
            disabled: loadingButton.value
          }, null, 8, ["title", "loading", "disabled"])
        ])
      ])
    ], 32)
  ]))
}
}

})